export const PERMS_KEY = "perms";
export const MODULE_LISTING_KEY = "module_listing";

export const setPerms = (perms = {}) => {
    localStorage.setItem(PERMS_KEY, JSON.stringify(perms));
};

export const setModuleListing = (data = {}) => {
    localStorage.setItem(MODULE_LISTING_KEY, JSON.stringify(data));
};

export const getPerms = () => {
    try {
        const stored = localStorage.getItem(PERMS_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (e) {
        return {};
    }
};

export const getModuleListing = () => {
    try {
        const stored = localStorage.getItem(MODULE_LISTING_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (e) {
        return {};
    }
};

export const hasPerm = (key) => {
    const perms = getPerms();
    return Boolean(perms?.[key]);
};

export const hasModuleListing = (key) => {
    const perms = getModuleListing();
    return Boolean(perms?.[key]);
};

export const normalizePermissions = (perms) => {
    const normalizeNode = (node) => {
        if (!node) return node;

        // if children is array → convert to object
        if (Array.isArray(node.children)) {
            const obj = {};

            node.children.forEach(child => {
                const key = Object.keys(child)[0];
                obj[key] = normalizeNode(child[key]);
            });

            node.children = obj;
        }

        return node;
    };

    const result = {};

    Object.keys(perms).forEach(key => {
        result[key] = normalizeNode(perms[key]);
    });

    return result;
};